import React  from 'react'
import { useTextResources } from '../../../language';
import DropDown from '../dropdown';
import { InvoiceStatuses } from '../constants';

const InvoiceStatusDropDown = ({...rest}) => {
    const text = useTextResources();
    const options = Object.entries(InvoiceStatuses).map(([key, value]) => ({
        Name: text(value),
        key: parseInt(key)
    }));

    return <DropDown data={options.filter(x => x.key !== 3)} textField="Name" valueField="key"  {...rest}/>
}

export default InvoiceStatusDropDown;

